Lesson (stxt.play.tutorial): Comments
	Progress: 3/5
	Explanation >>
		Comments are lines that start with #
		# This line is NOT a comment!!
		Remember: **Inside a block of text, everything is text**
	# This is an external comment, so it ends the block 'Explanation'
# This is a comment too

# ------------------
# Rules for comments
# ------------------
#  - The line must start with #
#  - They must be indented like nodes
#  - No comments inside blocks
#  - An external comment finishes a block of text
